// Section : Hero Header
// Style : Welcome Text on left and image on right

// import node module libraries
import { Col, Row, Container, Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';

// import media files
import HeroImage from 'assets/images/hero/hero-1.png';
import { PATH_DASHBOARD } from 'routes/Paths';

const HeroHeader = ({isAuth = false}) => {
	return (
		<section className="bg-dark-primary">
			<Container className="py-5">
				{/*  Hero Section  */}
				<Row className="align-items-center g-2">
					<Col xl={5} lg={6} md={12}>
						<div className="py-5 py-lg-0">
							<h1 className="text-white display-4 fw-bold">
								Welcome to Hope Arthritis Academy 
							</h1>
							<p className="text-white-50 mb-4 lead">
								Hand-picked Instructor and expertly crafted courses, designed
								for the modern students and medical practitioners.
							</p>
							<Link
								to={PATH_DASHBOARD.courses.browse}
								className="btn btn-dark"
							>
								Browse Courses
							</Link>{' '}
							{!isAuth &&
							<Link to="/authentication/sign-in/" className="btn btn-secondary">
								Get Access
							</Link>
							}
						</div>
					</Col>
					<Col xl={7} lg={6} md={12} className="text-lg-end text-center">
						<Image src={HeroImage} alt="" className="img-fluid" />
					</Col>
				</Row>
			</Container>
		</section>
	);
};
export default HeroHeader;
